/*** IMPORTS FROM imports-loader ***/
var _ = require("underscore/underscore");

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p +=
((__t = ( begin_tab(model.attributes.Name, {open: true, html_options: {'class': 'details-tab'}}))) == null ? '' : __t) +
'\n<div class="static-details">\n</div>\n<div class="form-group">\n    ' +
((__t = ( label_for(model, 'Secret', 'Secret', {
        'class': 'control-label'
    }))) == null ? '' : __t) +
'\n    ' +
((__t = ( input_for(model, 'Secret', 'password', {
        'class': 'form-control secret',
        'readonly': 'readonly'
    }))) == null ? '' : __t) +
'\n    <div class="col-sm-4">\n        <button type="button" class="btn btn-default show-secret">Show Secret</button>\n        <button type="button" class="btn btn-default reset-secret">Reset Secret</button>\n   </div>\n</div>\n' +
((__t = ( end_tab())) == null ? '' : __t) +
'\n' +
((__t = ( begin_tab('Permission', {html_options: {'class': 'permissions-tab'}}))) == null ? '' : __t) +
'\n' +
((__t = ( end_tab())) == null ? '' : __t);

}
return __p
}



//////////////////
// WEBPACK FOOTER
// ./public/views/admin/plugins/Details.ejs
// module id = 936
// module chunks = 1